import React, { useEffect, useRef, useState, useContext } from "react";
import Chart from "chart.js/auto";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";
import { Link, useLocation, useParams } from "react-router-dom";

const ViewBudget = () => {
  const chartRef = useRef(null);
  const [loadDati, setLoadDati] = useState({});
  const [loadDati1, setLoadDati1] = useState({});
  const apiToken = useContext(TokenContext);
  const [chartInstance, setChartInstance] = useState(null);

  let sommaImportoTotale = 0;
  let sommaContoTotaleDelCittadino = 0;
  let SommaImportoDovutoPagato = 0;
  let SommaImportoDovutoNonPagato = 0;
  let NumeroPagamenti = 0;
  let ContoTotalePrestazione = 0;

  const { paramId } = useParams();

  const [userId, setUserId] = useState("");

  if (Array.isArray(loadDati) && loadDati.length > 0) {
    sommaImportoTotale = loadDati.reduce(
      (acc, item) => acc + item.SommaImportoDovutoTotale,
      0
    );

    sommaContoTotaleDelCittadino = loadDati.reduce(
      (acc, item) => acc + item.ContoTotaleDelCittadino,
      0
    );

    SommaImportoDovutoPagato = loadDati.reduce(
      (acc, item) => acc + item.SommaImportoDovutoPagato,
      0
    );

    SommaImportoDovutoNonPagato = loadDati.reduce(
      (acc, item) => acc + item.SommaImportoDovutoNonPagato,
      0
    );

    NumeroPagamenti = loadDati.reduce(
      (acc, item) => acc + item.NumeroPagamenti,
      0
    );

    ContoTotalePrestazione = loadDati.reduce(
      (acc, item) => acc + item.ContoTotalePrestazione,
      0
    );
  } else {
    //console.error('loadDati non è un array valido o è vuoto');
  }

  const [selectedValue, setSelectedValue] = useState(""); // Imposta il valore predefinito

  const handleChange = (event) => {
    const { value } = event.target;
    setSelectedValue(value);
  };

  useEffect(() => {
    if (paramId === undefined) {
      setUserId("");
    } else {
      setUserId(paramId);
    }

    loadData(); // Chiamare loadData all'interno di useEffect

    return () => {
      // Cleanup del grafico precedente quando il componente si dismonta
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  }, [apiToken, userId]);

  const loadData = () => {
    setLoadDati([]);
    Repo.GetBudget(apiToken, userId)
      .then((response) => {
        setLoadDati(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    // Cleanup del grafico precedente
    if (chartInstance) {
      chartInstance.destroy();
    }

    // Check if data is available
    if (loadDati.length > 0) {
      const labels = loadDati.map((item) => item.Name);
      const data = loadDati.map((item) => item.ContoTotaleDelCittadino);

      const newChartInstance = new Chart(ctx, {
        type: "pie",
        data: {
          labels: labels,
          datasets: [
            {
              data: data,

              backgroundColors: [
                "#FF5733",
                "#33FF57",
                "#3373FF",
                "#FF33A1",
                "#A133FF",
              ],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      });

      // Aggiorna lo stato con la nuova istanza del grafico
      setChartInstance(newChartInstance);
    }
  }, [loadDati]);

  useEffect(() => {
    loadData1();
  }, [apiToken, userId]);

  const loadData1 = () => {
    setLoadDati1([]);
    Repo.GetGPresenze(apiToken, userId, selectedValue)
      .then((response) => {
        setLoadDati1(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleConferma = () => {
    // Logica per confermare, ad esempio chiamare loadData() e loadData1()
    loadData();
    loadData1();
  };

  const handleAnnulla = () => {
    setSelectedValue("");
    setLoadDati1([]);
    setLoadDati([]);
    loadData();
    loadData1();
  };

  return (
    <div>
      <h1>Budget</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Statistiche</p>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card-wrapper">
            <div className="card">
              <div className="card-body">
                <div>
                  <div className="row mt-2">
                    <div className="form-group col-md-6">
                      <div className="form-group">
                        <label className="active" htmlFor="dateStandard">
                          Data inizio
                        </label>
                        <input
                          type="date"
                          id="dateStandard"
                          name="dateStandard"
                        />
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <div className="form-group">
                        <label className="active" htmlFor="dateStandard">
                          Data fine
                        </label>
                        <input
                          type="date"
                          id="dateStandard"
                          name="dateStandard"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <div className="select-wrapper">
                        <label htmlFor="selectID">Intervento</label>
                        <select
                          id="selectID"
                          value={selectedValue}
                          onChange={handleChange}
                        >
                          <option value="">Tutti</option>
                          {Array.isArray(loadDati) &&
                            loadDati.map((item, index) => (
                              <option key={index} value={item.Id}>
                                {item.Name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col text-right">
                      <button
                        type="button"
                        className="btn btn-outline-primary mr-2"
                        onClick={() => handleAnnulla()}
                      >
                        Annulla
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={() => handleConferma()}
                      >
                        Conferma
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-8">
          <canvas ref={chartRef} width="400" height="400" />
        </div>
        <div className="col-4">
          <p>
            Totale costo per intervento{" "}
            <strong>{ContoTotalePrestazione && ContoTotalePrestazione} </strong>
          </p>

          <p>
            Totale Numero Pagamenti emessi{" "}
            <strong>{NumeroPagamenti && NumeroPagamenti}</strong>
          </p>

          <p>
            Totale importo erogato{" "}
            <strong>{sommaImportoTotale && sommaImportoTotale} €</strong>
          </p>

          <p>
            Totale ImportoDovutoPagato{" "}
            <strong>
              {SommaImportoDovutoPagato && SommaImportoDovutoPagato} €
            </strong>
          </p>

          <p>
            Totale ImportoDovutoNonPagato{" "}
            <strong>
              {SommaImportoDovutoNonPagato && SommaImportoDovutoNonPagato} €
            </strong>
          </p>
        </div>
      </div>
      <h3 className="mt-3">Bandi con partecipazione del cittadino</h3>

      {/* Aggiungi la tabella di riepilogo */}
      <table className="table mt-3">
        <thead>
          <tr>
            <th scope="col">Nome intervento</th>
            <th scope="col">Pagamenti emessi</th>

            <th scope="col">Totale dovuto</th>
            <th scope="col">Pagato</th>
            <th scope="col">Da pagare</th>
          </tr>
        </thead>
        <tbody>
          {loadDati &&
            Array.isArray(loadDati) &&
            loadDati.map((item) => (
              <tr key={item.Id}>
                <td>{item.Name}</td>
                <td>{item.NumeroPagamenti} </td>

                <td>{item.SommaImportoDovutoTotale} €</td>
                <td>{item.SommaImportoDovutoPagato} €</td>
                <td>{item.SommaImportoDovutoNonPagato} €</td>
              </tr>
            ))}
        </tbody>
      </table>

      <h3 className="mt-3">Dettaglio</h3>

      {/* Aggiungi la tabella di riepilogo */}
      <table className="table mt-3">
        <thead>
          <tr>
            <th scope="col">Nome intervento</th>

            <th scope="col">Nominativo</th>
            <th scope="col">Costo</th>
            <th scope="col">Ore intervento</th>
          </tr>
        </thead>
        <tbody>
          {loadDati1 &&
            Array.isArray(loadDati1) &&
            loadDati1.map((item, index) => (
              <tr key={index}>
                <td>{item.Name}</td>
                <td>{item.FullName} </td>
                <td>{item.TotaleCosto} €</td>
                <td>{item.TotaleOreServizio} </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViewBudget;
